import Vue from 'vue';
// import dayjs from 'dayjs';

  // 'January', 'February', 'March',
  // 'April', 'May', 'June', 'July',
  // 'August', 'September', 'October',
  // 'November', 'December'
const monthNames = [
  'Enero', 'Febrero', 'Marzo',
  'Abril', 'Mayo', 'Junio', 'Julio',
  'Agosto', 'Septiembre', 'Octubre',
  'Noviembre', 'Diciembre'
]

const dayNames = [
  'Lunes', 'Martes', 'Miércoles',
  'Jueves', 'Viernes', 'Sábado', 'Domingo'
]

// Evitar 1 cifra. Por defecto, los números de una cifra se muestran sin un cero delante
const locale = navigator.language;

// Fix error new Date NaN en Safari & IE . error en Chrome con dateTime SQL
const fixDateForAllBrowsers = dateString => dateString.replace(/-/g, '/');

// fix error con datetime
const fixDateTimeForAllBrowsers = dateString => dateString.replace(" ", "T");

// dateString.replace("", "T") // fix Safari & Chrome
// dateString.replace(/-/g, '/') //fix Safari

Vue.filter('number', function (value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})

Vue.filter('decimalTWO', function (value) {
  return parseFloat(value).toFixed(2).replace('.', ',')
})

Vue.filter('cutDecimalTWO', function (value) {
  // If the backend returns an integer, if you use .toFixed(2),
  // 0 will be automatically added later. If it is 3.6700, add parseFloat and print 3.67
  let data = parseFloat(( parseInt( value * 100 ) / 100 ).toFixed(2))
  return data.toString().replace('.', ',')

  // const a = value.toString();
  // // return a.substring(0, a.length -1).replace('.', ',')
  // return a.slice(0, -1).replace('.', ',');
})

Vue.filter('toFixedNoRounding', function (value) {
  const n = 2;
  const reg = new RegExp("^-?\\d+(?:\\.\\d{0," + n + "})?", "g")
  const a = value.toString().match(reg)[0];
  const dot = a.indexOf(".");
  if (dot === -1) { // integer, insert decimal dot and pad up zeros
      return a + "." + "0".repeat(n);
  }
  const b = n - (a.length - dot) + 1;
  const result =  b > 0 ? (a + "0".repeat(b)) : a;
  return result.replace('.', ',')
})




Vue.filter('DateDMY', function (value) {
  if (value) {

    let date = new Date(fixDateTimeForAllBrowsers(value))
    let day = date.getDate()
    let monthIndex = date.getMonth()
    let year = date.getFullYear()

    return day + ' ' + monthNames[monthIndex] + ' ' + year
  } else {
    return '-'
  }
})


Vue.filter('DateSimple', function (value) {
  if (value) {

    // return dayjs(value).format('DD/MM/YYYY');

    let date = new Date(fixDateTimeForAllBrowsers(value))
    let day = date.getDate()
    let m = date.getMonth() + 1;
    let mes = (m < 10) ? '0' + m : m;
    let dia = (day < 10) ? '0' + day : day;

    return `${dia}/${mes}/${date.getFullYear()}`

    // const options = {day: '2-digit', month: '2-digit', year: 'numeric'};
    // const separator = '/';
    // // replaceAll('/', separator)
    // return new Date(value).toLocaleDateString(locale, options).split('/').join(separator)

  } else {
    return '-'
  }
})

// ok Safari
Vue.filter('Timeh:m:s', function (value) {
  if (value) {

    // return dayjs(value).format('HH:mm:ss');

    let date = new Date(fixDateTimeForAllBrowsers(value))
    let hour = date.getHours()
    let minutes = date.getMinutes()
    let seconds = date.getSeconds()

    let minutos = (minutes < 10) ? '0' + minutes : minutes
    let segundos = (seconds < 10) ? '0'+ seconds : seconds

    return `${hour}:${minutos}:${segundos}`

  } else {
    return '-'
  }
})


Vue.filter('Timeh', function (value) {
  if (value) {

    // return dayjs(value).format('HH:mm:ss');

    let date = new Date(fixDateTimeForAllBrowsers(value))
    let hour = date.getHours()
    let minutes = date.getMinutes()
    let seconds = date.getSeconds()

    let minutos = (minutes < 10) ? '0' + minutes : minutes
    let segundos = (seconds < 10) ? '0'+ seconds : seconds

    return `${hour}:${minutos}:${segundos}`

  } else {
    return '-'
  }
})

Vue.filter('DateTimeDMYhms', function (value) {
  if (value) {


    let date = new Date(fixDateTimeForAllBrowsers(value))
    let day = date.getDate()
    let year = date.getFullYear()
    let m = date.getMonth() + 1;

    let mes = (m < 10) ? '0' + m : m;
    let dia = (day < 10) ? '0' + day : day;

    let hour = date.getHours()
    let minutes = date.getMinutes()
    let seconds = date.getSeconds()

    let minutos = (minutes < 10) ? '0' + minutes : minutes
    let segundos = (seconds < 10) ? '0'+ seconds : seconds

    // return `${hour}:${minutes}:${seconds}`

    // return `${day} ${monthIndex + 1} ${year}`

    return `${dia}/${mes}/${date.getFullYear()} ${hour}:${minutos}:${segundos}`
  } else {
    return '-'
  }
})

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('img', function (value) {
  return require('@/assets/img/' + value)
})

Vue.filter('card_date', function (card) {

  const today = new Date();
  const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
  const todayArray = today.toLocaleDateString("es-ES", options).split('/');  // 21/1/2021

  const mes = +todayArray[1];
  const anyo = todayArray[2];

  let data = {
    date: '',
    is_expirated: false
  };

  let month = mes;
  let fullYear = anyo;

  if (card.expiration_date) {

    if (card.expiration_date.length > 4) {
      fullYear = card.expiration_date.split('/')[0];
      month = card.expiration_date.split('/')[1];

    } else {
      const year = card.expiration_date.substr(0,2);
      fullYear = anyo.substr(0,2) + year;
      month = card.expiration_date.substr(2,2);
    }

    if ( mes > +month && +anyo >= +fullYear || +anyo >= +fullYear ) {
      data.is_expirated = true;
    }

    data.date += `${month}/${fullYear}`

  } else {
    data.date = "Sin datos"
  }

  return data.date;

})



